import { render } from "./InfoButton.vue?vue&type=template&id=5cb7bdaf&scoped=true"
import script from "./InfoButton.vue?vue&type=script&lang=js"
export * from "./InfoButton.vue?vue&type=script&lang=js"

import "./InfoButton.vue?vue&type=style&index=0&id=5cb7bdaf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5cb7bdaf"

export default script